export class ScrollTop {
	scrollTop: HTMLElement = document.querySelector("[data-scroll-top]");
	visibleClass: string = "visible";
	constructor() {
		this.scrollTopFunction();
		this.scrollOnClickFunction();
		window.addEventListener("scroll", this.scrollTopFunction, false);
	}

	private scrollTopFunction = () => {
		let windowHeight: number = window.innerHeight;
		let documentHeight: number = document.body.offsetHeight;
		let scrollTop: number = window.pageYOffset || document.documentElement.scrollTop;
		// add class if user scrolls more than 700 or reaches the bottom
		if ((scrollTop >= 700) || scrollTop + windowHeight > documentHeight - 100) {
			this.scrollTop.classList.add(this.visibleClass);
		} else {
			this.scrollTop.classList.remove(this.visibleClass);
		}
	}
	private scrollOnClickFunction = () => {
		this.scrollTop.addEventListener("click", () => {
			window.scrollTo({
				'behavior': 'smooth',
				'left': 0,
				'top': 0
			});
		});
	}
}
